module.exports = __webpack_public_path__ + "img/activity1.85ba98f9.png";